'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _OlxPayBadge = require('../../atoms/OlxPayBadge');

var _OlxPayBadge2 = _interopRequireDefault(_OlxPayBadge);

var _OlxDeliveryBadge = require('../../atoms/OlxDeliveryBadge');

var _OlxDeliveryBadge2 = _interopRequireDefault(_OlxDeliveryBadge);

var _style = require('./style');

var _colors = require('../../../behaviors/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OLXPayPlusDelivery(_ref) {
  var color = _ref.color,
      reduced = _ref.reduced,
      theme = _ref.theme;

  var lineColor = (0, _colors.getThemeColor)(color, theme) || color;
  return _react2.default.createElement(
    _style.Wrapper,
    null,
    _react2.default.createElement(_OlxPayBadge2.default, { reduced: reduced, height: 16 }),
    _react2.default.createElement(
      _style.PlusLabel,
      null,
      '+'
    ),
    _react2.default.createElement(
      _style.WrapperDelivery,
      null,
      _react2.default.createElement(_OlxDeliveryBadge2.default, { reduced: reduced, height: 16, color: lineColor })
    )
  );
}

OLXPayPlusDelivery.propTypes = {
  color: _propTypes2.default.string,
  reduced: _propTypes2.default.bool,
  // eslint-disable-next-line
  theme: _propTypes2.default.any
};

OLXPayPlusDelivery.defaultProps = {
  color: 'secondary',
  reduced: true
};

OLXPayPlusDelivery.displayName = 'OLXPayPlusDelivery';

exports.default = (0, _styledComponents.withTheme)(OLXPayPlusDelivery);